import React from 'react';

const CogIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}>
    <path 
        strokeLinecap="round" 
        strokeLinejoin="round" 
        d="M9.594 3.94c.09-.542.56-1.007 1.113-1.113l.448-.113a9.002 9.002 0 012.705 0l.448.113c.553.106 1.023.571 1.113 1.113l.064.382a9.002 9.002 0 013.432 2.164l.32.22c.474.325.998.12 1.258-.332l.295-.512a9.002 9.002 0 012.163 3.432l-.22.32c-.452.658-.233 1.503.332 1.258l.512-.295a9.002 9.002 0 010 2.705l-.512.295c-.565.325-.784 1.17-.332 1.258l.22.32a9.002 9.002 0 01-2.163 3.432l-.295-.512c-.26-.452-.784-.657-1.258-.332l-.32.22a9.002 9.002 0 01-3.432 2.164l-.064.382c-.09.542-.56 1.007-1.113 1.113l-.448.113a9.002 9.002 0 01-2.705 0l-.448-.113c-.553-.106-1.023-.571-1.113-1.113l-.064-.382a9.002 9.002 0 01-3.432-2.164l-.32-.22c-.474-.325-.998-.12-1.258.332l-.295.512a9.002 9.002 0 01-2.163-3.432l.22-.32c.452-.658.233-1.503-.332-1.258l-.512.295a9.002 9.002 0 010-2.705l.512-.295c.565-.325.784-1.17.332-1.258l-.22-.32a9.002 9.002 0 012.163-3.432l.295.512c.26.452.784.657 1.258.332l.32-.22a9.002 9.002 0 013.432-2.164l.064-.382z" 
    />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

export default CogIcon;